module.exports = __webpack_public_path__ + "static/media/white-atw.c656ea09.png";